import HeaderBarPage from './HeaderBarPage'
export default HeaderBarPage
